import React from 'react';

export function WhyNowSection() {
  return (
    <section id="s-why-now" className="franchise-section">
      <div className="franchise-section__inner">
        <div className="franchise-why-now" data-reveal>
          <img className="franchise-why-now__fish" src="/assets/media/franchise/hero-section/fish-2.svg" alt="Рыбки" />
          <img className="franchise-why-now__growth" src="/assets/media/franchise/why-now-section/growth.svg" alt="Рост" />
          <div className="franchise-why-now__banner">ПОЧЕМУ СЕЙЧАС <br /> ЛУЧШЕЕ ВРЕМЯ <br /> ОТКРЫТЬ ДОСТАВКУ <br /> ЕДЫ</div>
          <div className="franchise-why-now__text">
            <div>
              <img src="/assets/media/franchise/why-now-section/food.svg" alt="Иконка" />
              <span style={{ marginLeft: '-27px' }}>Суши и пицца — в топ-2 <br /> категорий</span>
            </div>
            <div>
              <img src="/assets/media/franchise/why-now-section/local.svg" alt="Иконка" />
              <span>В небольших городах <br /> остаются свободные ниши</span>
            </div>
            <div>
              <img src="/assets/media/franchise/why-now-section/location-smalltown.svg" alt="Иконка" />
              <span>Гости всё чаще выбирают <br /> локальные бренды</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
